import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { parseTime } from '@/utils'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
    }
    let href = window.location.hash.slice(1)
    if (href.indexOf('?') > -1) {
      href = href.substr(0, href.indexOf('?'))
    }
    href = href.replace(/\d/g, '')
    config.headers['Router'] = href
    if (process.env.NODE_ENV !== 'production') {
      config.headers['X-Forwarded-For'] = '0.0.0.0'
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // console.log(response)
    const res = response.data
    const datetime = parseTime(new Date())
    const requestMessage = {
      route: window.location.hash.slice(1),
      requestId: `${response.config.url}[${datetime}]:${res.request_id}`
    }

    // const requestId = `${response.config.url}[${datetime}]:${res.request_id}`
    store.dispatch('app/saveRequestId', requestMessage)
    // -5:失败后特殊提示 3:密码过期
    if (res.code !== 0 && res.code !== 1 && res.code !== 2 && res.code !== 3 && res.code !== -5) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === -1002) {
        store.dispatch('timer/clear', 'unReadTimer')
        store.dispatch('timer/clear', 'unBannerTimer')
        if (!store.getters.user_message.is_other) {
          // 本人可以走静默重新登录
          store.dispatch('user/resetLoginDialog', true)
          return false
        } else {
          MessageBox.confirm(
            '你已被登出，可以取消继续留在该页面，或者重新登录',
            '确定登出',
            {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'message-box-reset'
            }
          ).then(() => {
            reload()
          })
        }
      }

      // 特殊报错信息
      const errorMessage = [
        'Update failed for dictionary tanwan_datahub.dim_site_id_dict',
        'DB::Exception: Dictionary tanwan_datahub.dim_site_id_dict',
        'DB::Exception: Dictionary tanwan_datahub.dim_site_id_full_dict',
        'DB::Exception: Too many simultaneous queries',
        'DB::Exception: Memory limit',
        'Out of Memory Pool size pre cal',
        'The cluster is out of memory',
        'Query exceeded maximum time limit of'
      ]
      if (res.message) {
        const message = errorMessage.find(_ => res.message.includes(_)) ? '当前系统繁忙，请缩小查询范围后再进行查询' : res.message
        Message({
          message: message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(res)
    } else if (res.code === 3) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      localStorage.setItem('code', '3')
      reload()
    } else {
      // 分组打印sql信息，统一管理
      if (response.data.data && response.data.data.sql) {
        console.groupCollapsed('sql信息')
        if (typeof response.data.data.sql === 'object') {
          for (const key in response.data.data.sql) {
            console.dir(response.data.data.sql[key])
          }
        } else if (typeof response.data.data.sql === 'string') {
          console.dir(response.data.data.sql)
        }
        console.groupEnd()
      }
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

const reload = () => {
  store.dispatch('user/resetToken').then(() => {
    router.push('/login')
    location.reload(true)
  })
}

export default service
